const EmailIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M0.625 6.25L10 11.25L19.375 6.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M17.5 18.125H2.5C2.00272 18.125 1.52581 17.9275 1.17417 17.5758C0.822544 17.2242 0.625 16.7473 0.625 16.25V3.75C0.625 3.25272 0.822544 2.77581 1.17417 2.42417C1.52581 2.07254 2.00272 1.875 2.5 1.875H17.5C17.9973 1.875 18.4742 2.07254 18.8258 2.42417C19.1775 2.77581 19.375 3.25272 19.375 3.75V16.25C19.375 16.7473 19.1775 17.2242 18.8258 17.5758C18.4742 17.9275 17.9973 18.125 17.5 18.125Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EmailIcon;
